import styled, { css } from 'styled-components'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

export const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  font-size: 14px;
`

export const Header = styled.div`
position: relative;
display: flex;
flex: 0 0 auto;
flex-direction: row;
flex-wrap: wrap;
align-items: center;
min-height: 87px;
font-size: 0.7rem;
background: var(--color-primary);

&::before {
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: url('${MoreHeaderParticles}');
  background-repeat: no-repeat;
  background-position: right top;
}
`

export const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const Content = styled.div`
  /*flex: 1 1 auto;
padding: 0;
overflow: auto;
width: 100%;*/
`

export const RouteGroup = styled.div`
  margin-bottom: 15px;
  border-top: 1px solid var(--color-fg-lighter);
`

export const Routes = styled.div``

export const Route = styled.div`
  display: block;
  border-bottom: 1px solid var(--color-fg-lighter);
  padding: 20px;
`

export const RouteHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  cursor: pointer;
`

export const RouteHeaderLeft = styled.div`
  width: calc(100% - 20px);
`

export const RouteHeaderRight = styled.div`
  width: 20px;
  align-items: flex-end;
  img {
    width: 1rem;
  }
`

export const RouteTitle = styled.div`
  font-family: var(--font-family-ayala-display-sans);
  display: block;
  font-weight: 600;
`

export const RouteDescription = styled.div`
  font-color: var(--color-fg-lighter);
`

export const Note = styled.div`
  padding: 20px;
  font-color: var(--color-fg-lighter);
`

export const RouteSchedules = styled.div`
  margin-top: 20px;
`

export const RouteItem = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid var(--color-fg-lighter);
  color: #000;

  ${props =>
    props.isLastChild &&
    css`
      border-bottom: 0px;
    `}
`

export const RouteItemLeft = styled.div`
  width: 40%;
`

export const RouteItemRight = styled.div`
  width: 60%;
`

export const RouteUnavailable = styled.div`
  background-color: #f1f1f1;
  border-radius: 4px;
  text-align: center;
  padding: 5px;
  font-size: 12px;
  margin-bottom: 20px;
`

export const MapWrapper = styled.div`
  height: 130px;
  margin-top: 10px;
`
